import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {SharedUiDialogModule} from '@snelstart/ui-dialog';
import {SharedUiListModule} from "@snelstart/ui-list";
import {SharedUiLoadingModule} from "@snelstart/ui-loading";
import {SharedUiOffCanvasModule} from "@snelstart/ui-off-canvas";
import {DomainLogicModule, WorkflowComponent} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiTabModule} from "@snelstart/ui-tab";
import {FeatureTaxWorkflowDetailsComponent} from "./tax-workflow-details/feature-tax-workflow-details.component";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {FeatureWorkflowItemComponent} from "./workflow-item/feature-workflow-item.component";

@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiListModule,
    SharedUiLoadingModule,
    SharedUiOffCanvasModule,
    DomainLogicModule,
    SharedUiTabModule,
    SharedUiAlertModule,
  ],
  declarations: [],
  exports: [],
})
export class FeatureTaxWorkflowDetailsModule {}
